/**
 * Maps @ngx-translate `LANG_CODE` values to BCP-47 locale ids understood by
 * Angular's `DatePipe` / `formatDate` (must match `registerLocaleData` usage).
 */
const TRANSLATE_LANG_TO_ANGULAR_LOCALE: Record<string, string> = {
  en: 'en-US',
  'ar-sa': 'ar',
  sp: 'es',
  'fr-ca': 'fr-CA',
};

export function translateLangToAngularDateLocale(translateLang: string | null | undefined): string {
  if (!translateLang) {
    return 'en-US';
  }
  return TRANSLATE_LANG_TO_ANGULAR_LOCALE[translateLang] ?? translateLang;
}
